// extracted by mini-css-extract-plugin
module.exports = {"label":"style__label___V4oT8","content":"style__content___1UUzH","iconWrapper":"style__iconWrapper___Cc9Sk"};